export const dashboard_bar_chart_palette = [
  '#1e40af',
  '#3b82f6',
  '#0284c7',
  '#0891b2',
  '#0d9488',
  '#059669',
  '#64748b',
  '#475569',
  '#334155',
  '#1e293b'
];
